import { GetProps, Input } from 'antd';
import { FC, useId } from 'react';
import { InputWrapper } from '../_common/InputWrapper';

interface Props extends GetProps<typeof Input.OTP> {
	label?: string;
	error?: string;
}

export const OTPInput: FC<Props> = props => {
	const {
		label, //
		error,
		status,
		className,
		...rest
	} = props;

	const id = useId();

	// * Render
	return (
		<InputWrapper
			label={label}
			error={error}
			className={className}
		>
			<Input.OTP
				{...rest}
				id={id}
				status={error ? 'error' : status}
			/>
		</InputWrapper>
	);
};
